export const backgroundConfig = {
  "Brand Light": "brandLight",
  White: "white",
  "White with Border": "whiteWithBorder",
  Grey: "grey",
} as const;
